<div class="col-xl-4 col-lg-6 col-md-6 grid-item case7">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/animation/01.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case7">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/animation/02.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case7">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/animation/03.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case7">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/animation/04.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case7">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/animation/05.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case7">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/animation/06.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>